import { type DeepPartialSkipArrayKey } from 'react-hook-form';

import {
  type CreateCustomRoleRequest,
  type ListRolesResponse,
  type Role,
  type UpdateCustomRoleRequest,
} from '@column/api';

import { createApiHook } from '~/hooks/utils/createApiHook';
import { RoleRepository } from '~/repositories/RoleRepository';

export const useCreateCustomRole = createApiHook<
  KeysCamelCaseDeep<Role>,
  DeepPartialSkipArrayKey<KeysCamelCaseDeep<CreateCustomRoleRequest>> & { mode?: 'live' | 'sandbox' }
>(RoleRepository.create);

export const useDeleteCustomRole = createApiHook<unknown, { roleId: string }>(RoleRepository.delete);

export const useGetCustomRole = createApiHook<KeysCamelCaseDeep<Role>, { roleId: string }>(RoleRepository.get, {
  triggerOnSessionStoreSubscribe: true,
});

export const useListRoles = createApiHook<KeysCamelCaseDeep<ListRolesResponse>, undefined>(RoleRepository.list, {
  triggerAutomatically: true,
  triggerOnSessionStoreSubscribe: true,
});

export const useUpdateCustomRole = createApiHook<
  KeysCamelCaseDeep<Role> & { pendingApproval: boolean },
  { roleId: string } & DeepPartialSkipArrayKey<KeysCamelCaseDeep<UpdateCustomRoleRequest>> & {
      mode?: 'live' | 'sandbox';
    }
>(RoleRepository.update);
